import parse from "html-react-parser"
import iftttLoader from "images/icons/icon-ifttt-loader.svg?raw"
import styles from "./messages.module.scss"

const ThinkingIndicator = () => (
  <div className={styles["row"]} data-testid="thinking-indicator" aria-label="Thinking">
    <span className={styles["thinking-loader"]} aria-hidden="true">
      {parse(iftttLoader)}
    </span>
  </div>
)

export default ThinkingIndicator
